import * as bootstrap from "bootstrap";
import $ from "jquery";

import "./gsap";

import "./header";

// A jQuery $( document ).ready() block
$(document).ready(function () {
  // Remove hash from url
  const removeHash = () => {
    const url = window.location.href;
    const noHashUrl = url.replace(/#.*$/, "");
    window.history.replaceState(null, "", noHashUrl);
  };

  if (window.location.hash) {
    removeHash();
  }

  // Setting sharers
  $(".sns-sharer").on("click", function () {
    const type = $(this).data("type");
    openSharer(type);
  });

  const openSharer = (type) => {
    const url = window.location.href;
    const text = document.title;

    // If you have a complete URL, use encodeURI. But if you have a part of a URL, use encodeURIComponent.
    const encodedUri = encodeURI(url);
    const u = encodeURIComponent(encodedUri);
    const t = encodeURI(text.replace(/ /g, "+"));

    const getSharerUrl = (type) => {
      switch (type) {
        case "twitter":
          return "https://twitter.com/intent/tweet?url=" + u + "&text=" + t;
          break;
        case "facebook":
          return "https://www.facebook.com/sharer.php?u=" + u;
          break;
        case "linkedin":
          return "https://www.linkedin.com/sharing/share-offsite/?url=" + u;
          break;
        case "email":
          return "mailto:?subject=" + text + "&body=" + u;
          break;
      }
    };

    const sharerUrl = getSharerUrl(type);

    if (type === "email") {
      window.open(sharerUrl, "tab");
    } else {
      console.log(navigator.userAgent);
      const isMobile = () =>
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent,
        );

      if (isMobile === true) {
        window.open(sharerUrl, "_self");
      } else {
        const windowFeatures =
          "popup=true,left=100,top=100,width=500,height=500";
        window.open(sharerUrl, "popUpWindow", windowFeatures);
      }
    }
  };

  // Changing the width of second column of each episode at breakpoint
  if ($(window).width() < 1104) {
    if ($(".episode__second-column").hasClass("col-md-auto")) {
      $(".episode__second-column").removeClass("col-md-auto");
      $(".episode__second-column").addClass("col-12");
    }
  }

  $(window).resize(function () {
    if ($(window).width() < 1104) {
      if ($(".episode__second-column").hasClass("col-md-auto")) {
        $(".episode__second-column").removeClass("col-md-auto");
        $(".episode__second-column").addClass("col-12");
      }
    } else if ($(window).width() >= 1104) {
      if ($(".episode__second-column").hasClass("col-12")) {
        $(".episode__second-column").removeClass("col-12");
        $(".episode__second-column").addClass("col-md-auto");
      }
    }
  });

  // Highlight each tab when viewing each section
  const sections = [
    { id: "#episode-1", tab: ".tabs__tab-1" },
    // { id: "#episode-2", tab: ".tabs__tab-2" },
    // { id: "#episode-3", tab: ".tabs__tab-3" },
    // { id: "#episode-4", tab: ".tabs__tab-4" },
  ];

  let viewportHeight = window.innerHeight;

  const getViewportSize = () => {
    viewportHeight = window.innerHeight;
  };

  const highlightTab = () => {
    getViewportSize();

    for (const section of sections) {
      const targetSection = document.querySelector(section.id);
      const targetTab = document.querySelector(section.tab);

      // Get a rect object
      const rect = targetSection.getBoundingClientRect();

      const positionFromTop = rect.top / viewportHeight;
      const positionFromBottom = rect.bottom / viewportHeight;

      if (positionFromTop <= 0.5 && positionFromBottom >= 0.5) {
        $(targetTab).addClass("active");
      } else {
        $(targetTab).removeClass("active");
      }
    }
  };

  highlightTab();

  // Set event listener for scrolling
  window.addEventListener("scroll", highlightTab);

  // Set event listener for window resize
  window.addEventListener("resize", highlightTab);

  // Set event listener for device orientation change
  window.addEventListener("orientationchange", highlightTab);

  // Tab behavior when clicking the tabs
  $(".tabs__tab").on("click", function (event) {
    window.removeEventListener("scroll", highlightTab);

    $(".tabs__tab").removeClass("active");
    $(this).addClass("active");
    window.addEventListener("scrollend", (event) => {
      removeHash();
      window.addEventListener("scroll", highlightTab);
    });
  });

  // Force browser to scroll to the top before the page is about to be unloaded
  const beforeUnloadHandler = (event) => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };

  window.addEventListener("beforeunload", beforeUnloadHandler);
});
